import { module } from 'angular';

import { DashboardModule } from './dashboard/dashboard.module';
import { AuthModule } from './auth/auth.module';
import { PublicModule } from './public/public.module';
import { statesLazyRoutesConfig } from './states-lazy-routing';
import { PaymentProcessModule } from './payment-process/payment-process.module';

// export const StatesModuleMain = module('app.states', [
//   AuthModule.name,
//   DashboardModule.name,
//   PublicModule.name,
//   PaymentProcessModule.name
// ])
//   .config(statesLazyRoutesConfig).name;


export const StatesModule = module('app.states', [
  AuthModule.name,
  DashboardModule.name,
  PublicModule.name,
  PaymentProcessModule.name
])
  .config(statesLazyRoutesConfig).name;



// WEBPACK FOOTER //
// ./app/states/states.module.ts